import { API_TYPES } from "../constants/api-types";
const defaultHeaders = new Headers();
defaultHeaders.append("Content-Type", "application/json");

async function request(method, url, params, token, isFormData = false) {
  let headers = defaultHeaders;

  if (token) {
    headers = new Headers(isFormData ? {} : defaultHeaders);
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (url.includes("Token")) {
    headers = new Headers(isFormData ? {} : defaultHeaders);
    headers.set("login-source", "auction");
  }

  let body;

  if (params && !isFormData) {
    body = JSON.stringify(params);
  }
  if (params && isFormData) {
    body = params;
  }

  try {
    const controller = new AbortController();
    const { signal } = controller;

    const timeoutId = setTimeout(() => controller.abort(), 300000);

    const [path, queryString] = url.split("?");
    const urlParams = new URLSearchParams(queryString || "");

    const baseUrlParam = urlParams.get("base_url");
    urlParams.delete("base_url");

    const finalQueryString = urlParams.toString();
    const fullPath = finalQueryString ? `${path}?${finalQueryString}` : path;

    const CONTACT_BASE = process.env.REACT_APP_CONTACT_BASE_URL;
    const COMPANY_BASE = process.env.REACT_APP_COMPANY_BASE_URL;
    const INVENTORY_BASE = process.env.REACT_APP_INVENTORY_BASE_URL;
    const DEFAULT_BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL;

    let base;

    if (baseUrlParam === API_TYPES.CONTACTS) {
      base = CONTACT_BASE;
    } else if (baseUrlParam === API_TYPES.COMPANIES) {
      base = COMPANY_BASE;
    } else if (baseUrlParam === API_TYPES.INVENTORY) {
      base = INVENTORY_BASE;
    } else {
      base = DEFAULT_BACKEND_URL;
    }

    const response = await fetch(`${base}${fullPath}`, {
      headers,
      method,
      body,
      signal,
    });

    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return { error };
  }
}

// async function request(method, url, params, token, isFormData = false) {
//     let headers = defaultHeaders;

//     if (token) {
//       headers = new Headers(isFormData ? {} : defaultHeaders);
//       headers.set('Authorization', `Bearer ${token}`);
//     }

//     if (url.includes('Token')) {
//         headers = new Headers(isFormData ? {} : defaultHeaders);
//         headers.set('login-source', 'auction');
//       }

//     let body;

//     if (params && !isFormData) {
//       body = JSON.stringify(params);
//     }
//     if (params && isFormData) {
//       body = params;
//     }

//     try {
//         const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}${url}`, { headers, method, body });

//         return response;
//     } catch (error) {
//         return {error}
//     }

//     // return {error};
// }

// export const generateQueryString = (paramsObject, filteredItems) => {
//     return `?${filteredItems.map(param => `${param}`).join('+')}`;
// }

export const generateQueryString = (paramsObject) =>
  `?${Object.keys(paramsObject)
    .map((param) => `${param}=${encodeURIComponent(paramsObject[param])}`)
    .join("&")}`;

export const generateSearchParams = (params) => {
  const defaultParams = {
    searchString: "",
    page_number: "",
    page_size: "",
    models: "",
    makes: "",
    years: "",
    categories: "",
    locations: "",
    families: "",
  };

  const mergedParams = { ...defaultParams, ...params };

  return generateQueryString(mergedParams);
};

export const generateLookupParams = (params) => {
  const defaultParams = {
    auctionType: false,
    itemCategory: false,
    imageCategory: false,
    itemYear: false,
    itemMake: false,
    itemModel: false,
    competitor: false,
    contactType: false,
    event: false,
    location: false,
    motivationType: false,
    meterType: false,
    packageOwner: false,
  };

  const mergedParams = { ...defaultParams, ...params };

  return generateQueryString(mergedParams);
};

export const parseQueryString = (paramsString) =>
  JSON.parse(
    paramsString
      ? // eslint-disable-next-line no-div-regex
        '{"' +
          paramsString
            .replace("?", "")
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      : "{}"
  );

export const get = async (url, token) => request("GET", url, null, token);
export const create = async (url, params, token, isFormData) =>
  request("POST", url, params, token, isFormData);
export const update = async (url, params, token) =>
  request("PUT", url, params, token);
export const remove = async (url, params, token) =>
  request("DELETE", url, params, token);
